import clsx from "clsx"
export default function Plus({ className = '' }) {
  return (
    <svg className={clsx(className, 'w-(--space-5) lg:w-(--space-7) h-auto')} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className="lg:stroke-2" d="M8.00098 1L8.00098 15M1 8.00195L15 8.00195" stroke="#38362D" strokeWidth="1.39493" />
    </svg>
  )
}
